import React from 'react';
import { Box, Typography } from '@mui/material';
import { SectionContainer } from '../ui/SectionContainer';
import { ABOUT_CONTENT } from '../../constants';

interface MissionSectionProps {
  compact?: boolean;
}

/**
 * Mission section for the About page
 * Displays the company mission statement
 */
export const MissionSection: React.FC<MissionSectionProps> = ({ compact = false }) => {
  return (
    <SectionContainer variant="white" compact={compact}>
      <Box sx={{ maxWidth: 800, mx: 'auto' }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            mb: 4,
            fontSize: { xs: '1.75rem', md: '2rem' },
          }}
        >
          {ABOUT_CONTENT.mission.title}
        </Typography>

        {ABOUT_CONTENT.mission.paragraphs.map((paragraph, index) => (
          <Typography
            key={index}
            variant="body1"
            color="text.secondary"
            sx={{
              mb: 3,
              lineHeight: 1.8,
              fontSize: '1.1rem',
              '&:last-child': { mb: 0 },
            }}
          >
            {paragraph}
          </Typography>
        ))}
      </Box>
    </SectionContainer>
  );
};
